export default {"src":"/_next/static/media/alertIcon.11bdd267.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};